import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header-datepicker__body"
}

import IconDownload from '@/components/images/IconDownload.vue'
import IconCalendar from '@/components/images/IconCalendar.vue'
import ClientAutocomplete from './ClientAutocomplete.vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import dayjs from 'dayjs'
import useDataRequest from '@/composables/useDataRequest'
import { downloadReport } from '@/api/order'
import { downloadFile } from '@/utils/helpers'
import store from '@/store'


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportDownload',
  setup(__props) {

const showPicker = ref(false)

const date = ref([dayjs().subtract(1, 'day').toDate(), dayjs().subtract(1, 'day').toDate()])
const clientId = ref<number|null>(null)
const pickerWrapperRef = ref()
const request = useDataRequest()

const formattedDate = computed(() => date.value.map(value => dayjs(value).format('DD.MM.YYYY')).join(' - '))

const clickListener = (event: MouseEvent) => {
  if (pickerWrapperRef.value !== event.target && !pickerWrapperRef.value.contains(event.target)) {
    showPicker.value = false
  }
}

const handleDownload = () => {
  request.tryRequest(async () => {
    const period = date.value.map(value => dayjs(value).format('YYYY-MM-DD')) as [string, string]
    const response = await downloadReport({
      period,
      client_id: clientId.value,
      region_id: store.state.regionId
    })
    const filename = 'report-' + (period[0] === period[1] ? period[0] : period.join(' - ')) + '.xls'
    downloadFile(response, filename)
  })
}

onMounted(() => {
  document.addEventListener('click', clickListener)
})

onUnmounted(() => {
  document.removeEventListener('click', clickListener)
})

return (_ctx: any,_cache: any) => {
  const _component_vue_date_picker = _resolveComponent("vue-date-picker")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ClientAutocomplete, {
      modelValue: clientId.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((clientId).value = $event))
    }, null, 8, ["modelValue"]),
    _withDirectives((_openBlock(), _createElementBlock("a", {
      class: "header__report",
      href: "#",
      onClick: _withModifiers(handleDownload, ["prevent"])
    }, [
      _createVNode(IconDownload),
      _createTextVNode(" Отчет за " + _toDisplayString(formattedDate.value), 1)
    ])), [
      [_directive_loading, _unref(request).state.pending]
    ]),
    _createElementVNode("div", {
      ref_key: "pickerWrapperRef",
      ref: pickerWrapperRef,
      class: "header-datepicker"
    }, [
      _createElementVNode("button", {
        class: "header-datepicker__toggle",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showPicker.value = !showPicker.value))
      }, [
        _createVNode(IconCalendar)
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (showPicker.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_vue_date_picker, {
                  modelValue: date.value,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((date).value = $event)),
                    _cache[3] || (_cache[3] = ($event: any) => (showPicker.value = false))
                  ],
                  "time-picker": false,
                  locale: "ru",
                  inline: "",
                  "enable-time-picker": false,
                  "auto-apply": "",
                  "hide-offset-dates": "",
                  range: {
            maxRange: 14
          }
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 512)
  ], 64))
}
}

})